import { Flex, Typography } from 'antd'
import React, { ReactNode } from 'react'
import { DesignSystem } from '~/core/designSystem'

type Props = {
  label?: ReactNode
  description?: ReactNode
  children: ReactNode
}

export const InputWrapper: React.FC<Props> = ({
  label,
  description,
  children,
}) => {
  const designSystem = DesignSystem.use()

  return (
    <Flex
      gap={8}
      className="mb-2"
      align={designSystem.isMobile ? undefined : 'center'}
      vertical={designSystem.isMobile}
    >
      <Flex vertical flex={1}>
        {label && (
          <Typography.Text style={{ fontWeight: 500 }}>{label}</Typography.Text>
        )}
        {description && (
          <Typography.Text type="secondary">{description}</Typography.Text>
        )}
      </Flex>

      {children}
    </Flex>
  )
}
